import { Pipe, PipeTransform } from '@angular/core';
import { Status, statusMappings } from '../enums/Status';

@Pipe({
	name: 'statusLabel',
	standalone: true,
})
export class StatusLabelPipe implements PipeTransform {
	transform(status: Status): string {
		return statusMappings[status] || '';
	}
}
